import { timeFormatter } from '../formatters/time.formatter.js';
import { REFI_ESIGN_CONST } from '../../../constants/app.constants.js';

export class DebugService {
  constructor(classname) {
    this.classname = classname ? `${classname}::` : classname;
    this.blnDebug = !REFI_ESIGN_CONST.isProdEnv;
    this.blnHasConsole = false;
    this.defaultClassname = 'No Classname::';
  }

  log(...args) {
    this._console('info', ...args);
  }

  error(...args) {
    this._console('error', ...args);
  }

  _console(method, ...args) {
    if (this.classname === null || this.classname === undefined) {
      this.classname = this.defaultClassname;
    }

    if (this.blnDebug) {
      const timestr = timeFormatter();
      console[method](`[${timestr}]`, this.classname, ...args);
    }
  }
}
